import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import { getStorage, connectStorageEmulator } from 'firebase/storage'
import { getAnalytics, isSupported } from 'firebase/analytics'

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'contextfiregcp.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'contextfiregcp',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'contextfiregcp.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '',
}

// Check if Firebase is properly configured
const isConfigured = firebaseConfig.apiKey && firebaseConfig.appId

// Initialize Firebase (only if properly configured)
let app: any = null
let auth: any = null
let db: any = null
let storage: any = null
let analytics: any = null

if (isConfigured) {
  try {
    app = initializeApp(firebaseConfig)
    auth = getAuth(app)
    
    // Initialize Firestore with the 'contextmd' database (not default)
    const databaseId = import.meta.env.VITE_FIRESTORE_DATABASE_ID || 'contextmd'
    db = getFirestore(app, databaseId)
    storage = getStorage(app)
    
    // Connect to emulators in development
    if (import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true') {
      // Firestore emulator (default port 8080)
      connectFirestoreEmulator(db, 'localhost', 8080)
      
      // Auth emulator (default port 9099)
      connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
      
      // Storage emulator (default port 9199)
      connectStorageEmulator(storage, 'localhost', 9199)
    }
    
    // Initialize Analytics only if supported and measurement ID is provided
    if (firebaseConfig.measurementId) {
      isSupported().then((supported) => {
        if (supported) {
          analytics = getAnalytics(app)
        }
      }).catch((error) => {
        console.warn('Firebase Analytics initialization failed:', error)
      })
    }
    
    console.log('Firebase initialized successfully with contextmd database')
  } catch (error) {
    console.warn('Firebase initialization failed:', error)
  }
} else {
  console.warn('Firebase not configured. Please add your Firebase credentials to .env.local')
}

export { auth, db, storage, analytics }
export default app